import React from "react";
import { Button, CalendarDate, ChevronLeft, CursorClick01, TileGroup, UserPlus01 } from "@opendate-app/setlist";

import { useCustomCampaignShowContext } from "../CustomCampaignShowContainer";
import EventTriggerForm from "./EventTriggerForm";

const TRIGGER_TYPES = [
  { value: "Event", label: "Calendar", supportingText: "The state of a calendar event changes", icon: CalendarDate },
  { value: "Fan action", label: "Fan", supportingText: "A fan performs a specific action", icon: UserPlus01 },
  { value: "System Event", label: "Event", supportingText: "A specific event across the Opendate platform", icon: CursorClick01 },
];

export default () => {
  const {
    selectedNode,
    selectedNodeFormState,
    setSelectedNodeFormState,
  } = useCustomCampaignShowContext();

  const setTriggerType = (type) => {
    setSelectedNodeFormState(prevState => ({
      ...prevState,
      node_data: {
        ...prevState.node_data,
        trigger_type: type,
      },
    }));
  };

  const resetTriggerType = () => {
    setSelectedNodeFormState(prevState => ({
      ...prevState,
      node_data: {
        trigger_type: null,
        event_type: null,
      },
    }));
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      {!selectedNode?.node_data?.trigger_type && selectedNodeFormState?.node_data?.trigger_type ? (
        <div>
          <Button variant="link-color" size="sm" icon={ChevronLeft} onClick={resetTriggerType}>
            Change Trigger
          </Button>
        </div>
      ) : null}
      {!selectedNodeFormState?.node_data?.trigger_type ? (
        <TileGroup
          aria-label="Trigger type"
          columns={1}
          items={TRIGGER_TYPES}
          value={null}
          onChange={setTriggerType}
        />
      ) : (
        <EventTriggerForm />
      )}
    </div>
  );
};
